/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartSunburstAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M12 2h-1v4.083A6.005 6.005 0 0 0 6.083 11H2v1c0 3.742 1.67 6.279 3.777 7.851C7.839 21.391 10.303 22 12 22h1v-4.083A6.005 6.005 0 0 0 17.917 13H22v-1c0-3.742-1.67-6.279-3.777-7.851C16.161 2.609 13.697 2 12 2zm5.917 9A6.005 6.005 0 0 0 13 6.083V4.081c1.22.185 2.726.7 4.027 1.67C18.484 6.84 19.694 8.506 19.95 11zM4.05 13h2.033A6.005 6.005 0 0 0 11 17.917v2.002c-1.22-.185-2.726-.7-4.027-1.67C5.516 17.16 4.306 15.494 4.05 13zM8 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgChartSunburstAlt as ChartSunburstAlt };
